import { createTheme, Theme, ThemeProvider } from '@mui/material/styles';
import type {} from '@mui/lab/themeAugmentation';
import '@mui/lab/themeAugmentation';
const capacitamos = {
  palette: {
    type: 'light',
    primary: {
      main: '#005375',
    },
    secondary: {
      main: '#1285AB',
    },
    warning: {
      main: '#dc6600'
    }
  },
  components: {
    MuiTimeline: {
      styleOverrides: {
        root: {
          backgroundColor: 'red',
        },
      },
    },
  },
}

const ingles247 = {
  palette: {
    type: 'light',
    primary: {
      main: '#ff8000', //e42128
    },
    secondary: {
      main: '#213064',
    },
    warning: {
      main: '#dc6600'
    }
  },
  components: {
    MuiTimeline: {
      styleOverrides: {
        root: {
          backgroundColor: 'white',
        },
      },
    },
  },
}

export const themeOptions: ThemeOptions = capacitamos

export default createTheme(themeOptions);